import FavoritePlace from './FavoritePlace.container';

export default FavoritePlace;
